"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _excluded = ["dataMetrics", "value", "inputProps"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    focusVisible: {
      '&.Mui-checked': {
        border: "0px solid ".concat(theme.palette.primary[800])
      },
      border: "0px solid ".concat(theme.palette.opacity.black[87])
    }
  };
});
var defaultProps = {
  color: 'primary',
  dataMetrics: {
    root: 'fuse_checkbox'
  }
};
var Checkbox = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var dataMetrics = _ref.dataMetrics,
    value = _ref.value,
    inputProps = _ref.inputProps,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles();
  var internalInputProps = _objectSpread({
    'aria-label': "checkbox-label-".concat(value)
  }, inputProps);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], (0, _extends2["default"])({
    ref: ref
  }, rest, {
    "data-metrics": mergedDataMetrics.root,
    focusVisibleClassName: classes.focusVisible,
    id: "checkbox-label-".concat(value),
    inputProps: internalInputProps,
    value: value
  }));
});
Checkbox.defaultProps = defaultProps;
Checkbox.displayName = 'Checkbox';
Checkbox.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If `true` the component is checked.
   */
  checked: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes["default"].node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](https://v4.mui.com/api/checkbox/#css) for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes["default"].oneOf(['primary', 'secondary', 'default']),
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * If `true` the switch will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes["default"].node,
  /**
   * The id of the `input` element.
   */
  id: _propTypes["default"].string,
  /**
   * If `true` the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the input.
   */
  indeterminate: _propTypes["default"].bool,
  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: _propTypes["default"].node,
  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes["default"].shape({
    'aria-label': _propTypes["default"].string
  }),
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing event.target.checked.
   * @param {boolean} checked The checked value of the switch.
   */
  onChange: _propTypes["default"].func,
  /**
   * The value of the component.
   */
  value: _propTypes["default"].string
} : {};
var _default = Checkbox;
exports["default"] = _default;